import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, STEP_STATE, THEME } from 'ng-wizard';

@Component({
  selector: 'app-cashback-steps',
  templateUrl: './cashback-steps.component.html',
  styleUrls: ['./cashback-steps.component.scss']
})
export class CashbackStepsComponent implements OnInit {
  createCashbackFlag = true
  whiteListFlag = true
  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden
  };

  config: NgWizardConfig = {
    selected: 0, //default selected value
    theme: THEME.arrows,
    toolbarSettings: {}
  };

  cashback_id:any

  constructor(
    private ngWizardService: NgWizardService,
    private route : Router,
    private activateRoute : ActivatedRoute 
  ) {
    this.activateRoute.params.subscribe((res:any)=>{
      if(res.data == 0){
        this.cashback_id = 0
        console.log('create button clicked',res.data)
        this.whiteListFlag = false
      }
      else{      
        console.log(res)
        console.log(res.data)
        this.whiteListFlag = true
        this.cashback_id = parseInt(res.data)
        this.createCashbackData(true) 
        setTimeout(()=>{
          this.goPreviusStep()
        },500)
        console.log('edit button clicked',res.data)
      }
    })
   }

  ngOnInit() {

  }

  createCashbackData(e){
    console.log(e)
    if(e == true){
      this.whiteListFlag = true
      setTimeout(()=>{
        this.ngWizardService.next()
      },500)
    }
  }
  receiveCashBackID(e){
    console.log(e)
    setTimeout(() => {
    this.cashback_id = e
    }, 1000);
  }

  goPreviusStep(){
    this.ngWizardService.previous()
  }
}
